module.exports = __webpack_public_path__ + "assets/img/NoTasks@3x.0c8e019e.png";